import React from "react";
import { Form } from "react-final-form";
import { EditQuestionModal } from "./modules/EditQuestionModal/EditQuestionModal";
import { useEditQuestionModal } from "./utils/useEditQuestionModal";

export const EditQuestionForm = ({
  handleEditQuestion,
  showQuestionPlacementField = true,
}) => {
  const { questionInitialValues } = useEditQuestionModal();

  const { closeEditQuestionModal } = useEditQuestionModal();
  return (
    <Form
      initialValues={{ questionObj: questionInitialValues }}
      onSubmit={(formData, form) =>
        handleEditQuestion({
          formData,
          form,
          onSuccess: closeEditQuestionModal,
        })
      }
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <EditQuestionModal
            handleSubmit={handleSubmit}
            showQuestionPlacementField={showQuestionPlacementField}
          />
        </form>
      )}
    </Form>
  );
};
